// pages/Home.js
import { useState } from 'react';
import Card from '../components/Card';
import Button from '../components/Button';
import '../styles/Home.css';
import PDFViewerModal from '../components/PDFViewerModal';

const Home = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPdfUrl, setSelectedPdfUrl] = useState('');

  const openModalWithPdf = (url) => {
    setSelectedPdfUrl(url);
    setIsModalOpen(true);
  };

  return (
    <div className="page">
      <h1 className="title">カリキュラム概要ページ</h1>

      <Card title="カリキュラム概要">
        <p>このカリキュラムは、ITリテラシーの習得から始まり、実務的なSNS運用・LP制作・AIツール活用・プレゼン能力など、デジタル業務の即戦力となるスキルの獲得を目指しています。</p>
        <p>AIで未来の仕事力を育てる。実務に直結するスキルを、AIツール・SNS運用・Web制作を通じて習得。初心者からでも安心して学べる、実践重視のオンラインカリキュラムです。</p>
      </Card>

      {/*<Card title="想定されるスキルごとのキャリアパス">
        <div className="skill-tree">
          <ul>
            <li>
              <strong>オフィスソフトの操作</strong><br />
              <span>想定職種：事務職、営業事務、一般事務、教育補助員</span>
              <ul>
                <li>習得スキル：Word/Excel/PowerPoint操作、資料作成能力</li>
              </ul>
            </li>
            <li>
              <strong>AIとITリテラシー</strong><br />
              <span>想定職種：PCサポートスタッフ、ITサポート、データ入力業務</span>
              <ul>
                <li>習得スキル：基本操作、AIツール（ChatGPT、翻訳など）の使用法、LP作成の初歩</li>
              </ul>
            </li>
            <li>
              <strong>SNS運用と画像生成・編集</strong><br />
              <span>想定職種：SNS運用代行、デジタルマーケティングアシスタント、広報・販促担当</span>
              <ul>
                <li>習得スキル：SNSコンテンツの企画と投稿、KPIの理解、Canva・Recraft・画像生成AIの活用</li>
              </ul>
            </li>
            <li>
              <strong>LP制作（HTML・CSS）</strong><br />
              <span>想定職種：Webアシスタント、HTMLコーダー、マーケティング部門のWeb更新担当</span>
              <ul>
                <li>習得スキル：HTML/CSSによる簡易Web制作、SEO対策、UX/UI設計基礎</li>
              </ul>
            </li>
            <li>
              <strong>LP・SNS実案件対応</strong><br />
              <span>想定職種：Webマーケター、Webディレクターアシスタント、広告運用サポート</span>
              <ul>
                <li>習得スキル：KPI設計、分析（Google Analyticsなど）、A/Bテスト、クライアント向け資料作成</li>
              </ul>
            </li>
          </ul>
        </div>
      </Card>*/}
      
      <Card title="カリキュラム構成と各セッション一覧">
        <section className="curriculum-section">
          <h3>🖥 基礎編</h3>

          <div className="curriculum-block">
            <h4>1. ITリテラシー・AIの基本（全6回）</h4>
            <Button onClick={() => openModalWithPdf('/download/C1.pdf')}>詳細を見る</Button>
          </div>

          <div className="curriculum-block">
            <h4>2. SNS運用の基礎・画像生成編集（全12回）</h4>
            <Button onClick={() => openModalWithPdf('/download/C2.pdf')}>詳細を見る</Button>
          </div>

          <div className="curriculum-block">
            <h4>3. LP制作（HTML・CSS）（全12回）</h4>
            <Button onClick={() => openModalWithPdf('/download/C3.pdf')}>詳細を見る</Button>
          </div>
        </section>

        <section className="curriculum-section">
          <h3>🎮 応用編（選択制）</h3>

          <div className="curriculum-block">
            <h4>4. AIによる画像・動画生成（全12回）</h4>
            <p>画像・動画生成AIの基礎</p>
          </div>

          <div className="curriculum-block">
            <h4>5. AIによるマーケティング実践（全12回）</h4>
            <p>マーケティングに基づいたSNS管理代行・LP制作</p>
            <Button onClick={() => openModalWithPdf('/download/C5.pdf')}>詳細を見る</Button>
          </div>

          <div className="curriculum-block">
            <h4>6. ゲーム開発</h4>
            <p>Unreal Engine（アンリアルエンジン）基礎</p>
          </div>
        </section>

        <section className="curriculum-section">
          <h3>📰 その他（選択制）</h3>

          <div className="curriculum-block">
            <h4>7. Microsoft Officeの操作・文書作成（全6回）</h4>
            <Button onClick={() => openModalWithPdf('/download/C7.pdf')}>詳細を見る</Button>
          </div>
        </section>
      </Card>

      <div style={{ marginTop: '2rem' }}>
        <Button onClick={() => window.open('/download/AIを活用した業務を学ぶ_カリキュラム.pdf', '_blank')}>カリキュラム概要PDF</Button>
      </div>

      <PDFViewerModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        pdfUrl={selectedPdfUrl}
      />
    </div>
  );
};

export default Home;
